
import React from 'react';
import { DefaultButton } from  'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

const ButtonCommandMscMode = (props) => {

    const classNames = mergeStyleSets({
        default: {
            backgroundColor: 'rgba(128, 128, 128, 0.7)'
        },
        selected: {
            backgroundColor: 'rgba(64, 64, 64, 0.7)'
        }
    });

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.modeId);
        }
    }

    const getClassName = () => {
        return (props.selected) ? classNames.selected : classNames.default;
    }

    return (
        <DefaultButton
            className={getClassName()}
            text={props.title}
            onClick={onClick}
            styles={{
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    color: '#ffffff'
                }
            }}
        />
    );
}

export default ButtonCommandMscMode;
